/* global module */
(function (objGlobal) {
  'use strict';
  function buildQuery(strKeyword, strPredicate) {
    const arrTokens = strKeyword.trim().slice(0, 160).split(/\s+/).filter(Boolean);
    const strLiteral = arrTokens.map(strToken => '"' + strToken.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"').join(' AND ');
    return [strLiteral ? '(' + strLiteral + ')' : '', strPredicate].filter(Boolean).join(' AND ');
  }
  function resultsUrl(strOrigin, strRoot, objState, strPredicate) {
    const strQuery = buildQuery(objState.q, strPredicate);
    const objUrl = new URL(strRoot.replace(/\/?$/, '/') + (strQuery ? 'search' : 'collections/all'), strOrigin);
    objUrl.searchParams.set('section_id', 'lucid-smart-search-results');
    objUrl.searchParams.set('page', String(objState.page));
    if (strQuery) {
      objUrl.searchParams.set('q', strQuery);
      objUrl.searchParams.set('type', 'product');
      objUrl.searchParams.set('options[unavailable_products]', 'last');
    }
    objUrl.searchParams.set('sort_by', strQuery ? (objState.sort === 'created-descending' ? 'relevance' : objState.sort) : (objState.sort === 'relevance' ? 'created-descending' : objState.sort));
    return objUrl;
  }
  function safeStoreUrl(strValue, strOrigin) {
    try { const objUrl = new URL(strValue, strOrigin); return objUrl.origin === strOrigin && /^https?:$/.test(objUrl.protocol) ? objUrl.href : null; }
    catch (objError) { return null; }
  }
  function latestRequest() {
    let intGeneration = 0;
    return { begin: () => ++intGeneration, isCurrent: intValue => intValue === intGeneration };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {buildQuery, resultsUrl, safeStoreUrl, latestRequest};
  if (typeof document === 'undefined') return;
  function init(objShell) {
    if (objShell.dataset.ready) return;
    objShell.dataset.ready = '1';
    const objConfig = JSON.parse(objShell.querySelector('[data-config]').textContent);
    const objCopy = objConfig.copy;
    const arrCategories = objConfig.categories;
    const objForm = objShell.querySelector('form');
    const objInput = objShell.querySelector('[data-query]');
    const objCategory = objShell.querySelector('[data-category]');
    const objSort = objShell.querySelector('[data-sort]');
    const objResults = objShell.querySelector('[data-results]');
    const objStatus = objShell.querySelector('[data-status]');
    const objTitle = objShell.querySelector('[data-results-title]');
    const objCount = objShell.querySelector('[data-count]');
    const objList = objShell.querySelector('[data-suggestions]');
    const objClear = objShell.querySelector('[data-clear]');
    const objGate = latestRequest();
    const objSuggestGate = latestRequest();
    let objAbort = null;
    let objSuggestAbort = null;
    let intTimer = 0;
    let intActive = -1;
    let objState = {q:'',category:'all',sort:'relevance',page:1};
    arrCategories.forEach(objItem => {
      const objOption = document.createElement('option');
      objOption.value = objItem.key; objOption.textContent = objItem.label;
      objCategory.appendChild(objOption);
      if (objItem.key !== 'all') {
        const objButton = document.createElement('button');
        objButton.type = 'button'; objButton.textContent = objItem.label;
        objButton.dataset.categoryKey = objItem.key;
        objShell.querySelector('[data-category-links]').appendChild(objButton);
      }
    });
    function syncControls() {
      const boolSearch = Boolean(objState.q || objState.category !== 'all');
      const objNewest = objSort.querySelector('[value="created-descending"]');
      const objRelevance = objSort.querySelector('[value="relevance"]');
      objNewest.disabled = boolSearch; objNewest.hidden = boolSearch;
      objRelevance.disabled = !boolSearch; objRelevance.hidden = !boolSearch;
      if (boolSearch && objState.sort === 'created-descending') objState.sort = 'relevance';
      if (!boolSearch && objState.sort === 'relevance') objState.sort = 'created-descending';
      objInput.value = objState.q; objCategory.value = objState.category; objSort.value = objState.sort;
      objClear.hidden = !objState.q;
      objShell.querySelectorAll('[data-category-key]').forEach(objButton => objButton.setAttribute('aria-pressed', String(objButton.dataset.categoryKey === objState.category)));
    }
    function readUrl() {
      const objParams = new URL(location.href).searchParams;
      objState.q = (objParams.get('q') || '').slice(0,160);
      objState.category = arrCategories.some(objItem => objItem.key === objParams.get('category')) ? objParams.get('category') : 'all';
      objState.sort = ['relevance','created-descending','price-ascending','price-descending'].includes(objParams.get('sort_by')) ? objParams.get('sort_by') : 'relevance';
      objState.page = Math.max(1, Math.min(objState.q || objState.category !== 'all' ? 42 : 1042, Number.parseInt(objParams.get('page'), 10) || 1));
      syncControls();
    }
    function writeUrl(boolPush) {
      const objUrl = new URL(location.href);
      ['q','category','sort_by','page'].forEach(strKey => objUrl.searchParams.delete(strKey));
      if (objState.q) objUrl.searchParams.set('q',objState.q);
      if (objState.category !== 'all') objUrl.searchParams.set('category',objState.category);
      if (objState.sort !== 'relevance') objUrl.searchParams.set('sort_by',objState.sort);
      if (objState.page > 1) objUrl.searchParams.set('page',String(objState.page));
      if (objUrl.href !== location.href) history[boolPush ? 'pushState' : 'replaceState']({},'',objUrl);
    }
    function closeSuggestions() {
      objList.hidden = true; objInput.setAttribute('aria-expanded','false');
      objInput.removeAttribute('aria-activedescendant'); intActive = -1;
    }
    function dismissSuggestions() {
      objSuggestGate.begin(); if (objSuggestAbort) objSuggestAbort.abort(); closeSuggestions();
    }
    function message(strHeading, strBody, boolError) {
      objResults.replaceChildren();
      const objBox = document.createElement('div'); objBox.className = 'ltss-empty';
      const objHeading = document.createElement('h3'); objHeading.textContent = strHeading;
      const objBody = document.createElement('p'); objBody.textContent = strBody;
      const objButton = document.createElement('button'); objButton.type='button'; objButton.className='ltss-button';
      objButton.textContent = boolError ? objCopy.retry : objCopy.reset;
      objButton.addEventListener('click', () => { if (!boolError) { objState={q:'',category:'all',sort:'relevance',page:1}; syncControls(); writeUrl(true); } loadResults(); });
      objBox.append(objHeading,objBody,objButton); objResults.appendChild(objBox);
    }
    async function loadResults() {
      const intStarted=performance.now();
      window.LucidSmartSearchTelemetry?.invalidate();
      const intGeneration = objGate.begin();
      if (objAbort) objAbort.abort(); objAbort = new AbortController();
      const objSelected = arrCategories.find(objItem => objItem.key === objState.category);
      const objUrl = resultsUrl(location.origin,objConfig.root,objState,objSelected.query);
      objResults.setAttribute('aria-busy','true'); objStatus.textContent=objCopy.loading;
      objShell.classList.add('ltss-loading'); objCount.textContent='';
      objTitle.textContent = !objState.q && objState.category === 'all' ? objCopy.latest : objCopy.results;
      try {
        const objResponse = await fetch(objUrl,{signal:objAbort.signal,headers:{'Accept':'text/html'}});
        if (!objResponse.ok) throw new Error('HTTP '+objResponse.status);
        const strHtml = await objResponse.text();
        const objDoc = new DOMParser().parseFromString(strHtml,'text/html');
        const objFragment = objDoc.querySelector('[data-ltss-result-set]');
        if (!objFragment) throw new Error('Missing result section');
        if (!objGate.isCurrent(intGeneration)) return;
        const intTotal = Number.parseInt(objFragment.dataset.total,10) || 0;
        const boolCapped = objFragment.dataset.capped === 'true';
        objCount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(intTotal) + (boolCapped ? '+' : '')+' '+objCopy.products;
        objStatus.textContent = objCount.textContent;
        if (intTotal === 0) message(objCopy.empty,objCopy.emptyHint,false);
        else {
          objResults.replaceChildren(document.importNode(objFragment,true));
          if (boolCapped) { const objNote=document.createElement('p'); objNote.className='ltss-limit'; objNote.textContent=objCopy.countLimit; objResults.appendChild(objNote); }
        }
        window.LucidSmartSearchTelemetry?.result({query:objState.q,category:objState.category,sort_by:objState.sort,page:objState.page,result_count:intTotal,capped:boolCapped,duration_ms:Math.min(120000,Math.round(performance.now()-intStarted)),locale:objConfig.telemetry?.platform===109?'de':objConfig.telemetry?.platform===151?'fr':'en',products:Array.from(objFragment.querySelectorAll('.ltss-product-link[data-product-id]')).map(objLink=>({id:objLink.dataset.productId,handle:objLink.dataset.productHandle}))});
      } catch (objError) {
        if (objError.name !== 'AbortError' && objGate.isCurrent(intGeneration)) { message(objCopy.error,'',true); objStatus.textContent=objCopy.error; }
      } finally {
        if (objGate.isCurrent(intGeneration)) { objResults.setAttribute('aria-busy','false'); objShell.classList.remove('ltss-loading'); }
      }
    }
    async function loadSuggestions() {
      const intGeneration = objSuggestGate.begin();
      if (objSuggestAbort) objSuggestAbort.abort(); objSuggestAbort = new AbortController();
      const strQuery = objInput.value.trim(); closeSuggestions();
      if (strQuery.length < 2) return;
      const objUrl = new URL(objConfig.root.replace(/\/?$/, '/')+'search/suggest.json',location.origin);
      objUrl.searchParams.set('q',strQuery);
      objUrl.searchParams.set('resources[type]','query'); objUrl.searchParams.set('resources[limit]','5');
      try {
        const objResponse=await fetch(objUrl,{signal:objSuggestAbort.signal});
        if (!objResponse.ok) return;
        const objData=await objResponse.json();
        if (!objSuggestGate.isCurrent(intGeneration) || document.activeElement !== objInput) return;
        const arrQueries=objData.resources?.results?.queries || [];
        objList.replaceChildren();
        arrQueries.slice(0,5).forEach((objQuery,intIndex) => {
          const strText=String(objQuery.text || ''); if (!strText) return;
          const objOption=document.createElement('li'); objOption.role='option'; objOption.id='ltss-suggestion-'+intIndex;
          objOption.textContent=strText; objOption.dataset.query=strText; objOption.setAttribute('aria-selected','false');
          objOption.addEventListener('mousedown',objEvent=>objEvent.preventDefault());
          objOption.addEventListener('click',()=>chooseSuggestion(strText)); objList.appendChild(objOption);
        });
        objList.hidden=!objList.children.length; objInput.setAttribute('aria-expanded',String(!objList.hidden));
      } catch (objError) { /* Suggestions are optional; full results remain usable. */ }
    }
    function chooseSuggestion(strQuery) {
      clearTimeout(intTimer); objState.q=strQuery.slice(0,160); objState.page=1;
      syncControls(); dismissSuggestions(); writeUrl(true); loadResults(); objInput.focus();
    }
    function updateSearch(boolPush) {
      clearTimeout(intTimer); objState.q=objInput.value.trim().slice(0,160); objState.category=objCategory.value;
      objState.sort=objSort.value; objState.page=1; syncControls(); writeUrl(boolPush); loadResults();
    }
    objForm.addEventListener('submit',objEvent=>{objEvent.preventDefault();dismissSuggestions();updateSearch(true);});
    objInput.addEventListener('input',()=>{
      objClear.hidden=!objInput.value; clearTimeout(intTimer);
      // Invalidate in-flight results immediately, before the debounce interval ends.
      objGate.begin(); if (objAbort) objAbort.abort(); objSuggestGate.begin(); if (objSuggestAbort) objSuggestAbort.abort();
      window.LucidSmartSearchTelemetry?.invalidate();
      closeSuggestions(); intTimer=setTimeout(()=>{updateSearch(false);loadSuggestions();},300);
    });
    objInput.addEventListener('focus',loadSuggestions);
    objInput.addEventListener('blur',dismissSuggestions);
    objInput.addEventListener('keydown',objEvent=>{
      if (objEvent.key==='Escape') {dismissSuggestions();return;}
      const arrOptions=Array.from(objList.children);
      if (objList.hidden || !arrOptions.length) return;
      if (objEvent.key==='ArrowDown' || objEvent.key==='ArrowUp') {
        objEvent.preventDefault(); intActive=intActive<0 ? (objEvent.key==='ArrowDown'?0:arrOptions.length-1) : (intActive+(objEvent.key==='ArrowDown'?1:-1)+arrOptions.length)%arrOptions.length;
        arrOptions.forEach((objOption,intIndex)=>objOption.setAttribute('aria-selected',String(intIndex===intActive)));
        objInput.setAttribute('aria-activedescendant',arrOptions[intActive].id);
      } else if (objEvent.key==='Enter' && intActive>=0) {objEvent.preventDefault();chooseSuggestion(arrOptions[intActive].dataset.query);}
    });
    objClear.addEventListener('click',()=>{objInput.value='';dismissSuggestions();updateSearch(true);objInput.focus();});
    objCategory.addEventListener('change',()=>{dismissSuggestions();updateSearch(true);});
    objSort.addEventListener('change',()=>updateSearch(true));
    objShell.addEventListener('click',objEvent=>{
      const objCategoryButton=objEvent.target.closest('[data-category-key]');
      if (objCategoryButton) {objCategory.value=objCategoryButton.dataset.categoryKey;dismissSuggestions();updateSearch(true);}
      const objTry=objEvent.target.closest('[data-try]'); if (objTry) chooseSuggestion(objTry.dataset.try);
      const objPage=objEvent.target.closest('[data-result-page]');
      if (objPage) {objEvent.preventDefault();objState.page=Number.parseInt(objPage.dataset.resultPage,10);writeUrl(true);loadResults();objTitle.focus({preventScroll:true});objTitle.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    });
    window.addEventListener('popstate',()=>{clearTimeout(intTimer);dismissSuggestions();readUrl();loadResults();});
    objCategory.disabled=false; objSort.disabled=false; objClear.disabled=false;
    readUrl(); loadResults();
  }
  function boot() {document.querySelectorAll('[data-ltss]').forEach(init);}
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})(typeof window !== 'undefined' ? window : globalThis);
